import { ReactNode } from 'react';

import { Box, SxProps } from '@mui/material';

const Container = ({ children, sx }: { children: ReactNode; sx?: SxProps }) => (
  <Box
    sx={{
      m: 1,
      position: 'relative',
      width: {
        xs: '100%',
        lg: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default Container;
